/**
 * 1.23 UI 도트 아이콘 — 글자 대신 쓰는 작은 그림. 게임과 같은 결(정수 격자, 네모 도트)로 찍는다.
 * 'X' 가 칠하는 칸. 색은 currentColor 라 CSS color 로 바꾼다.
 */
const BITMAPS = {
  heart: ['.XX.XX.', 'XXXXXXX', 'XXXXXXX', '.XXXXX.', '..XXX..', '...X...'],
  speed: ['X..X...', '.X..X..', '..X..X.', '...X..X', '..X..X.', '.X..X..', 'X..X...'],
  // 1.24 전격 질주를 든 대시 칸 — 번개 한 줄기
  bolt: ['....XX.', '...XX..', '..XX...', '.XXXXX.', '...XX..', '..XX...', '.XX....'],
  slash: ['......X', '.....X.', '....X..', 'X..X...', '.XX....', '.XX....', 'X..X...'],
  magic: ['...X...', '...X...', '..XXX..', 'XXXXXXX', '..XXX..', '...X...', '...X...'],
  xp: ['...X...', '..XXX..', '.XXXXX.', 'XXXXXXX', '.XXXXX.', '..XXX..', '...X...'],
  damage: ['X..X..X', '.X.X.X.', '..XXX..', 'XXXXXXX', '..XXX..', '.X.X.X.', 'X..X..X'],
  cards: ['XX.XX', 'XX.XX', '.....', 'XX.XX', 'XX.XX'],
  skull: ['.XXXXX.', 'XXXXXXX', 'X..X..X', 'XXXXXXX', '.XX.XX.', '.X.X.X.'],
  clock: ['..XXX..', '.X...X.', 'X..X..X', 'X..XX.X', 'X.....X', '.X...X.', '..XXX..'],
  crown: ['X..X..X', 'XX.X.XX', 'XXXXXXX', 'XXXXXXX'],
  level: ['...X...', '..XXX..', '.XXXXX.', '...X...', '...X...', '...X...'],
  speaker: ['...X...', '..XX.X.', 'XXXX..X', 'XXXX..X', '..XX.X.', '...X...'],
  mute: ['...X...', '..XX...', 'XXXX.X.X', 'XXXX..X.', '..XX.X.X', '...X...'],
  note: ['..XXXX', '..X..X', '..X..X', 'XXX.XX', 'XXX.XX'],
  back: ['...X...', '..X....', '.XXXXXX', '..X....', '...X...'],
  play: ['X....', 'XXX..', 'XXXXX', 'XXX..', 'X....'],
  chest: ['.XXXXX.', 'X.....X', 'XXXXXXX', 'X..X..X', 'X.....X', 'XXXXXXX'],
  finger: ['..X....', '..X....', '..XXXX.', 'X.XXXXX', 'XXXXXXX', '.XXXXX.', '..XXX..'],
} as const;

export type GlyphName = keyof typeof BITMAPS;

const cache = new Map<string, string>();

/** 도트 아이콘 SVG. px = 한 도트의 크기 */
export function glyph(name: GlyphName, px = 2, cls = ''): string {
  const key = `${name}|${px}|${cls}`;
  const hit = cache.get(key);
  if (hit) return hit;
  const rows = BITMAPS[name];
  const w = Math.max(...rows.map((r) => r.length));
  const h = rows.length;
  let rects = '';
  rows.forEach((r, y) => {
    // 가로로 이어진 칸은 한 네모로
    let x = 0;
    while (x < r.length) {
      if (r[x] !== 'X') {
        x++;
        continue;
      }
      let e = x;
      while (e < r.length && r[e] === 'X') e++;
      rects += `<rect x="${x}" y="${y}" width="${e - x}" height="1"/>`;
      x = e;
    }
  });
  const svg = `<svg class="glyph${cls ? ' ' + cls : ''}" width="${w * px}" height="${h * px}" viewBox="0 0 ${w} ${h}" fill="currentColor" shape-rendering="crispEdges" aria-hidden="true">${rects}</svg>`;
  cache.set(key, svg);
  return svg;
}
